import {
  faCartArrowDown,
  faCheck,
  faCheckCircle,
  faStore,
  faStoreAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import useReactRouter from "use-react-router";

function OrderMove() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const {history}=useReactRouter()
  const _gotoOrderList=()=>{
      history.push(`/orderlist`)
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10",
          fontWeight: "bold",
          fontSize: 16,
        }}
      >
        Move to...
      </div>
      <div
        style={{
          marginTop: 11,
          background: "#422F90",
          height: 38,
          padding: 10,
          borderRadius: 5,
          alignItems: "center",
          display: "flex",
        }}
        onClick={handleShow}
      >
        <FontAwesomeIcon style={{ color: "#FFFF" }} icon={faCartArrowDown} />
        <span style={{ marginLeft: 20, color: "#FFFF" }}>ອໍເດີ້ເຂົ້າ</span>
      </div>
      <div style={{ marginTop: 18 }}>
        <FontAwesomeIcon icon={faStore} />
        <span style={{ marginLeft: 20 }}>ກະກຽມຂົນສົ່ງ</span>
      </div>
      <div style={{ marginTop: 18 }}>
        <FontAwesomeIcon icon={faStoreAlt} />
        <span style={{ marginLeft: 20 }}>ກຳລັງສົ່ງ</span>
      </div>
      <div style={{ marginTop: 18 }}>
        <FontAwesomeIcon icon={faCheck} />
        <span style={{ marginLeft: 20 }}>ສົ່ງສຳເລັດ</span>
      </div>
      <div style={{ marginTop: 18 }}>
        <FontAwesomeIcon icon={faTimes} />
        <span style={{ marginLeft: 20 }}>ຍົກເລີກ</span>
      </div>
      <div
        className="d-grid gap-2"
        style={{ position: "fixed", bottom: 20, width: "80%" }}
      >
        <Button style={{ background: "#EAE8F3" }}>
          <span style={{ color: "#D21C1C" }}onClick={()=>_gotoOrderList()}>Cancle</span>
        </Button>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div style={{display:"flex",justifyContent:"center"}}>
            <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 80,color:"green" }} />          
          </div>
          <div style={{textAlign:"center",fontSize:24, fontWeight:"bold"}}>ເຄື່ອນຍ້າຍສຳເລັດ</div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default OrderMove;
